React = require 'react/addons'
AgeStore = require '../stores/age-store'
classSet = React.addons.classSet

module.exports =
  componentDidMount: ->
    ele = document.getElementById 'content-area'
    ele.className = classSet { content: true, 'slide-up': true }

  componentWillUnmount: ->
    ele = document.getElementById 'content-area'
    ele.className = classSet { content: true, 'slide-up': false }



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/mixins/animate-scroll.cjsx
 **/